import React from 'react';
import { Spinner } from 'react-bootstrap';
import { usePromiseTracker } from 'react-promise-tracker';

const ButtonLoader = ({ children, trackerArea }) => {
    const { promiseInProgress } = usePromiseTracker({ area: trackerArea });
    
    return (
        <>
            {promiseInProgress ? (
                <Spinner animation="border" variant="light" size="sm" />
            ) : ('')}
            <span className={promiseInProgress ? 'ml-2' : ''}>{children}</span>
        </>
    )
}

export default ButtonLoader;